import { Page } from "@/models/page-models/Page";

export const SalesPayments: Page = {
  "path": "sales-payments",
  "name": "Payment",
  "props": {
    "data": {
      "title": "Payment",
      "printable": "FALSE",
      "url": "sales-payments",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Invoice Payment",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openInvoicePaymentPage",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/create-payment-collection-receipt"
                      },
                      "name": "openInvoicePaymentPage"
                    }
                  ],
                  "showIf": "fn(NOT,fn(MATCH_ROLE,General | Manager))",
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Posted",
              "bracketValueFormula": "{{fetchedData.postedPayments.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Posted Payments",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.postedPayments.data}}",
                      "items": "fetchedData.postedPayments.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Payment Id",
                          "type": "url",
                          "url": "/invoice-payment-receipt/{{__item._id}}"
                        },
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "customerPaymentMode",
                          "text": "Mode Of Payment"
                        },
                        {
                          "value": "bankName",
                          "text": "Bank",
                          "align": "start"
                        },
                        {
                          "value": "amountReceived",
                          "text": "Amount",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                        },
                        {
                          "value": "approvedAt",
                          "text": "Posting Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.approvedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "pagination": {
                        "pageVariable": "fetchedData.postedPaymentsForm.page",
                        "serverItemsLengthVariable": "fetchedData.postedPayments.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPostedPayments",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/invoice-payment-receipt/search",
                              "arg2Key": "postData",
                              "arg2Value": "fetchedData.postedPaymentsForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.postedPayments"
                            },
                            "name": "getPostedPayments"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.postedPaymentsForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending",
              "bracketValueFormula": "fn(SUM,fn(LENGTH,{{fetchedData.pendingCreditNotes.data}}),fn(LENGTH,{{fetchedData.myInvoicePayments.data}}),,{{fetchedData.invoicePayments.data.totalDocs}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Credit Notes",
                      "disabled": "FALSE",
                      "showIf": "fn(LENGTH,{{fetchedData.pendingCreditNotes.data}})",
                      "items": "fetchedData.pendingCreditNotes.data",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Credit Note Id",
                          "type": "url",
                          "formula": "{{__item.typeId}}",
                          "url": "/credit-note/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "value",
                          "text": "Value",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.value}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "subtype",
                          "text": "Type"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve Selected",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveCreditNote",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/invoice-payment/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "storeResponse",
                                "arg3Value": "TRUE"
                              },
                              "name": "approveCreditNote"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "showApprovedCnSnackbar",
                                "type": "fnOpenSnackbar",
                                "color": "secondary",
                                "serverMessage": "Credit Note Approved, requesting ZATCA Clearance"
                              },
                              "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)",
                              "name": "showApprovedCnSnackbar"
                            },
                            {
                              "executionOrder": 3,
                              "pageFunction": {
                                "name": "clearCreditNote",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/e-invoicing/clear-invoice/{{__item._id}}?type=Credit Note",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "GET"
                              },
                              "name": "clearCreditNote",
                              "executeIf": "fn(LOGICAL,{{__response.data.typeId}},>,0)",
                            }
                          ]
                        },
                        {
                          "label": "Decline Selected",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "declineCreditNote",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/invoice-payment/{{__item._id}}/decline",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "declineCreditNote"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "70vh"
                    }
                  ],
                  "showIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "My Invoice Payments",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.myInvoicePayments.data}}",
                      "items": "fetchedData.myInvoicePayments.data",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Payment Id",
                          "type": "url",
                          "url": "/invoice-payment-receipt/{{__item._id}}"
                        },
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "customerPaymentMode",
                          "text": "Mode Of Payment"
                        },
                        {
                          "value": "bankName",
                          "text": "Bank",
                          "align": "start"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "amountReceived",
                          "text": "Amount",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Edit",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openEditPaymentCollection",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "update-payment-collection",
                                "arg2Key": "queryParams",
                                "arg2Value": "{\"receipt\":\"{{__item._id}}\"}"
                              },
                              "name": "openEditPaymentCollection"
                            }
                          ]
                        },
                        {
                          "label": "Validate Payment",
                          "disableIf": "fn(LOGICAL,fn(SUM,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),fn(LOGICAL,fn(CONCAT,',{{__item.0.status}},'),!==,'Pending')),!==,0)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "validateIpr",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/invoice-payment-receipt/{{__item._id}}/submit",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "fnsAfterSubmit",
                                "arg3Value": "getMyPendingPayments"
                              },
                              "name": "validateIpr"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true
                    }
                  ]
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Invoice Payments",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.invoicePayments.data.docs}}",
                      "items": "fetchedData.invoicePayments.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Payment Id",
                          "type": "url",
                          "url": "/invoice-payment-receipt/{{__item._id}}"
                        },
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "customerPaymentMode",
                          "text": "Mode Of Payment"
                        },
                        {
                          "value": "bankName",
                          "text": "Bank",
                          "align": "start"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "amountReceived",
                          "text": "Amount",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Edit",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openEditPaymentCollection",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "update-payment-collection",
                                "arg2Key": "queryParams",
                                "arg2Value": "{\"receipt\":\"{{__item._id}}\"}"
                              },
                              "name": "openEditPaymentCollection"
                            }
                          ]
                        },
                        {
                          "label": "Validate Payment",
                          "disableIf": "fn(LOGICAL,fn(SUM,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),fn(LOGICAL,fn(CONCAT,',{{__item.0.status}},'),!==,'Pending')),!==,0)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "validateIpr",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/invoice-payment-receipt/{{__item._id}}/submit",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "fnsAfterSubmit",
                                "arg3Value": "getPendingPayments"
                              },
                              "name": "validateIpr"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.invoicePaymentFilters.page",
                        "itemsPerPageVariable": "fetchedData.invoicePaymentFilters.limit",
                        "serverItemsLengthVariable": "fetchedData.invoicePayments.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getInvoicePayments"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Rejected",
              "bracketValueFormula": "{{fetchedData.rejectedPayments.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Rejected Payments",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.rejectedPayments.data}}",
                      "items": "fetchedData.rejectedPayments.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Payment Id",
                          "type": "url",
                          "url": "/invoice-payment-receipt/{{__item._id}}"
                        },
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "customerPaymentMode",
                          "text": "Mode Of Payment"
                        },
                        {
                          "value": "bankName",
                          "text": "Bank",
                          "align": "start"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "amountReceived",
                          "text": "Amount",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "pagination": {
                        "pageVariable": "fetchedData.rejectedPaymentsForm.page",
                        "serverItemsLengthVariable": "fetchedData.rejectedPayments.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getRejectedPayments",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/invoice-payment-receipt/search",
                              "arg2Key": "postData",
                              "arg2Value": "fetchedData.rejectedPaymentsForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.rejectedPayments"
                            },
                            "name": "getRejectedPayments"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.rejectedPaymentsForm.limit"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPendingCreditNotes",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/invoice-payment/pending-cn",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.pendingCreditNotes"
        },
        "name": "getPendingCreditNotes",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 2,
        "name": "getMyPendingPayments",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPostedPaymentsForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPostedPaymentsForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.postedPaymentsForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPostedPaymentsForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPostedPayments",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/invoice-payment-receipt/search",
          "arg2Key": "postData",
          "arg2Value": "fetchedData.postedPaymentsForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.postedPayments"
        },
        "name": "getPostedPayments"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultRejectedPaymentsForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultRejectedPaymentsForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.rejectedPaymentsForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultRejectedPaymentsForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getRejectedPayments",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/invoice-payment-receipt/search",
          "arg2Key": "postData",
          "arg2Value": "fetchedData.rejectedPaymentsForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.rejectedPayments"
        },
        "name": "getRejectedPayments"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultInvoicePaymentFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultInvoicePaymentFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.invoicePaymentFilters"
        },
        "name": "copyDefaultInvoicePaymentFilters"
      },
      {
        "executionOrder": 2,
        "name": "getInvoicePayments",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Sales | Manager),||,fn(MATCH_ROLE,General Manager))"
      }
    ],
    "functions": [
      {
        "name": "getMyPendingPayments",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/my-invoice-payment-receipts?status=Pending&status=Submitted",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.myInvoicePayments"
      },
      {
        "name": "getInvoicePayments",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice-payment-receipts?status=Submitted&status=Pending",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.invoicePayments",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.invoicePaymentFilters"
      },
      {
        "name": "getDefaultPostedPaymentsForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": ["Approved"]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultInvoicePaymentFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getDefaultRejectedPaymentsForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": ["Rejected", "Retracted"]
          }
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 73
}